import { useEffect } from 'react';

import { useParams } from 'react-router-dom';

import { useLocation, useNavigate } from '@utils/hooks';

import { useStore } from '@modules';
import { CryptoCurrencyEnum } from '@modules/global/types';

const useRedirectToDefaultCurrency = (): CryptoCurrencyEnum => {
  const { currency } = useParams<{ currency: CryptoCurrencyEnum }>();
  const navigate = useNavigate();
  const location = useLocation();
  const [{ global }] = useStore();
  const defaultCurrency = global.currencies.crypto[0] || CONST.defaultCryptoCurrency;

  const hasCryptoCurrency = !!currency && global.currencies.crypto.includes(currency);

  useEffect(() => {
    if (!hasCryptoCurrency && !currency) {
      navigate(`${location.pathname.replace(/\/$/, '')}/${defaultCurrency}`);
    }
  }, [defaultCurrency, currency]);

  return currency || defaultCurrency;
};

export default useRedirectToDefaultCurrency;
